/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refusal_Discord_Busy_LaterInputs */



/**
* | output |
* | --- |
* | "Discord asked us to slow down. Try again in a moment." |
*
* @param {Refusal_Discord_Busy_LaterInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_discord_busy_later = /** @type {((inputs?: Refusal_Discord_Busy_LaterInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Discord_Busy_LaterInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Discord попросил сбавить темп. Попробуйте снова чуть позже.")
	return /** @type {LocalizedString} */ ("Discord asked us to slow down. Try again in a moment.")
});